<template>
  <!-- <div></div> -->
  <div class="sidebar-footer wise-text-shadow">
    <!-- <p class="text-center">
      FAQ  |  문의사항  |  공지사항
    </p> -->
    <br /><br />

    <div class="wise-header-10 wise-margin-bottom-0">
      <p style="font-size:15px;font-weight:600">데이터 R&D 팀</p>
      <b-row style="font-size:12px;">
        <b-col sm="2">Mail</b-col>
        <b-col sm="9">rnd.dmc@sbs.co.kr</b-col>
      </b-row>
      <!-- <b-row style="font-size:12px;">
        <b-col sm="2">Phone</b-col>
        <b-col sm="9">정진완 차장 / 내선번호 623</b-col>
      </b-row>
      <b-row style="font-size:12px;">
        <b-col sm="2"></b-col>
        <b-col sm="9">이인성 박사 / 내선번호 690</b-col>
      </b-row> -->
    </div>
    <br>
    <div class="wise-font-10-default">
      <p class="wise-margin-bottom-0">
        DB업데이트 일자 : 2019.12.12
      </p>
      <p class="wise-margin-bottom-0">
        Copyright (c) DMC MEDIA since 2018
      </p>
      <p>
        All Right Reserved.
      </p>
    </div>
  </div>
</template>
<script>

export default {
  name: 'sidebar-footer'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Sidebar/SidebarFooter.vue